import { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import WeatherWidget from '../../components/WeatherWidget';
import CustomAppBar from '../../components/AppBar';
import CustomDashboardCard from '../../components/Custom/CustomDashboard';
import { useTranslation } from 'react-i18next';
import api from '../../globals/axios';
import PieChartData from '../../components/Custom/Charts';
import QuickLinks from '../../components/QuickLinks';
import getQuickLinks from '../../Data/iconsData';

const VLEDashboard = () => {
  const { t } = useTranslation();
  const [vleDetails, setVleDetails] = useState({});
  const [latestTarget, setLatestTarget] = useState(null);
  const quickLinksData = getQuickLinks('vle');

  const fetchVleDetails = async () => {
    try {
      const response = await api.get('/vle/get-vle-details/');
      setVleDetails(response.data);
    } catch (error) {
      console.error('Error Fetching VLE Details:', error);
    }
  };

  const fetchLatestTarget = async () => {
    try {
      const response = await api.get('/vle/target-progress/'); // Adjust the endpoint as needed
      setLatestTarget(response.data);
    } catch (error) {
      console.error('Error Fetching Latest Target:', error);
    }
  };

  const farmersPieChartData = {
    title: 'Farmers Target',
    labels: [t('Onboarded'), t('Remaining')],
    datasets: [
      {
        data: [
          latestTarget?.farmers_added,
          latestTarget?.farmer_target - latestTarget?.farmers_added,
        ],
        backgroundColor: ['#75C178', '#CF5C5C'],
        hoverBackgroundColor: ['#75C178', '#CF5C5C'],
      },
    ],
  };

  const areaPieChartData = {
    title: 'Area Target (acres)',
    labels: [t('Mapped'), t('Remaining')],
    datasets: [
      {
        data: [
          latestTarget?.total_area_added,
          latestTarget?.area_target - latestTarget?.total_area_added,
        ],
        backgroundColor: ['#75C178', '#CF5C5C'],
        hoverBackgroundColor: ['#75C178', '#CF5C5C'],
      },
    ],
  };

  useEffect(() => {
    fetchVleDetails();
    fetchLatestTarget();
  }, []);

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs" style={{ marginTop: 20 }}>
        <WeatherWidget />
        <Box mt={2}>
          <CustomDashboardCard
            title={t('Total Farmers')}
            data={vleDetails.farmer_count || 0}
          />
          <Grid container spacing={1} mt={0.5}>
            <Grid item xs={6}>
              <CustomDashboardCard
                title={t('Programs Completed')}
                data={vleDetails.completed_programs_count || 0}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomDashboardCard
                title={t('Assigned Programs')}
                data={vleDetails.total_assigned_programs || 0}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomDashboardCard
                title={t('Total Area')}
                data={vleDetails.total_area || 0.0}
                unit={`${t('acres')}`}
              />
            </Grid>
          </Grid>

          {latestTarget && (
            <Card variant="outlined" style={{ marginTop: 16 }}>
              <CardContent>
                <Typography variant="h6" component="h2">
                  {t('Targets for date')} : {latestTarget.target_date}
                </Typography>
                <Typography variant="body1">
                  {t('Farmers to onboard')} : {latestTarget.farmer_target}
                </Typography>
                <Typography variant="body1">
                  {t('Farmers onboarded')} : {latestTarget.farmers_added}
                </Typography>
                <Typography variant="body1">
                  {t('Area to be mapped')} : {latestTarget.area_target}
                  {t(' acres')}
                </Typography>
                <Typography variant="body1">
                  {t('Area mapped')} : {latestTarget.total_area_added}
                  {t(' acres')}
                </Typography>
                <Typography variant="body1">
                  {t('Your score')} : {latestTarget.vle_score}
                </Typography>
              </CardContent>
            </Card>
          )}
        </Box>
        {latestTarget && (
          <Box mt={1}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <PieChartData data={farmersPieChartData} t={t} />
              </Grid>
              <Grid item xs={12}>
                <PieChartData data={areaPieChartData} t={t} />
              </Grid>
            </Grid>
          </Box>
        )}
        <Box mt={2}>
          <QuickLinks data={quickLinksData} />
        </Box>
      </Container>
    </>
  );
};

export default VLEDashboard;
